
import wx from 'weixin-js-sdk'
import autho from '../autho/autho.js'
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
import router from '@/router'
const app = {
    async getJsTicket(url){
		console.log(url);
        var that = this;
        const res = await autho.request('token','get','/gzhWxApiController/getjsconfig',{url:url})
            autho.resetDataFun(res,function(){
                that.wxChatFun(res.data.data)
            })

        // const res = await axios({
        //     headers: {'token':autho.token},
        //     method: 'get',
        //     url: autho.http_url + '/gzhWxApiController/getjsconfig',
        //     params: {
        //         url
        //     }
        // })
        // if(res.data.status == 200){
        //     this.wxChatFun(res.data.data)
        // } 
    },
    wxChatFun(res){
        console.log(res)
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appid, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature,// 必填，签名
            jsApiList: ['chooseWXPay','updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });
        wx.ready(function(){
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            // wx.updateAppMessageShareData({ 
            //     title: 'aaa', // 分享标题
            //     desc: 'bbb', // 分享描述
            //     link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            //     imgUrl: '', // 分享图标
            //     success: function () {
            //         // 设置成功
            //     }
            // })
            // //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            // wx.updateTimelineShareData({ 
            //     title: 'ttt', // 分享标题
            //     link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            //     imgUrl: '', // 分享图标
            //     success: function () {
            //       // 设置成功
            //     }
            // })
        })
    },
    payFun(res){
        wx.ready(function(){
            wx.chooseWXPay({
                timestamp: res.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
                package: res.packageVal, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: res.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                paySign: res.paySign, // 支付签名
                success: function (data) {
					// 支付成功后的回调函数            
					if (data.errMsg == "chooseWXPay:ok") {                 
						//支付成功  
						Toast({message:'支付成功',forbidClick:true,duration:3000});
						setTimeout(() => {
							router.push('/')
							}, 2000);
						} else {                 
							//支付失败        
							Toast({message:'支付失败',forbidClick:true});
						}   
		
                }
              });
        })
    }
}

export default app